Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.SingleDimensionViewBaseFactory
  constructor: (session) ->
    @session = session
    @barMenuViewFactory = new Common.Dashboard.Charts.BarMenuViewFactory

  canHandle: (widget) ->
    throw new Error('Not implemented')

  create: (widget, data, isReadOnly, isResponsive) ->
    throw new Error('Not implemented')

  _createSortDropdown: (widget) ->
    new Common.Sessions.SortDropdown(widget.get('sorting')) if widget.canSort()

  _nameTranslator: (widget) ->
    attribute = @session.findAttribute(widget.get('definition_code'))
    factory = new CustomerVisualMode.WidgetDataTranslatorFactory(@session.accountAttributes, attribute)
    factory.create(widget.get('dimension'))

  _valueTranslator: (widget) ->
    factory = new CustomerVisualMode.WidgetValueTranslatorFactory()
    factory.create(widget.get('dimension'))

  _chartToRender: (widget, dataFormatter, data) ->
    CHART_TYPE = Common.Dashboard.Widget.ChartType
    chartClass = switch widget.get('chart_type')
      when CHART_TYPE.bar then CustomerVisualMode.Charts.BarGraphChartView
      when CHART_TYPE.pie then CustomerVisualMode.Charts.PieGraphChartView
      when CHART_TYPE.column then CustomerVisualMode.Charts.ColGraphChartView
    new chartClass(data: dataFormatter.format(widget, data))
